<template>
  <FieldBox
    :title="$t('trade.before-after-market-open-deal')"
    class="outside-rth"
  >
    <RadioBox v-model="outsideRth" :disabled="disabled" :options="rthTypes" />
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import { ORDER_TYPE } from 'const/trade'
import FieldBox from '../FieldBox'
import RadioBox from '../RadioBox'
export default {
  name: 'OrderRthField',
  components: { FieldBox, RadioBox },
  props: {
    addOrder: String // profit, loss
  },
  computed: {
    ...mapGetters(['tradeRequest']),
    stock() {
      return this.tradeRequest.stock
    },
    order() {
      return this.tradeRequest.order
    },
    orderType() {
      return this.order.orderType
    },
    disabled() {
      return this.tradeRequest.isModify
    },
    // 主订单限价单
    isLMT() {
      return [ORDER_TYPE.LMT, ORDER_TYPE.STP_LMT].includes(this.orderType)
    },
    // 附加止盈单（即限价单）
    isAddPROFIT() {
      return this.addOrder === 'profit'
    },
    isAddLOSS() {
      return this.addOrder === 'loss'
    },
    outsideRth: {
      get() {
        if (this.isAddLOSS) {
          return !this.order.stopLossRth
        } else if (this.isAddPROFIT) {
          return !this.order.profitTakerRth
        } else {
          return this.order.outsideRth
        }
      },
      set(outsideRth) {
        const params = {}
        if (this.isAddPROFIT) {
          params.profitTakerRth = !outsideRth
        } else if (this.isAddLOSS) {
          params.stopLossRth = !outsideRth
        } else {
          params.outsideRth = outsideRth
        }
        this.$store.dispatch('updateTradeOrder', params)
      }
    },
    rthTypes() {
      const types = [
        {
          value: false,
          label: this.$t('trade.rth'),
          tooltip: this.$t('trade.rth-full')
        },
        {
          value: true,
          label: this.$t('trade.eth'),
          tooltip: this.$t('trade.eth-full')
        }
      ]
      // 仅限价单支持延长时段交易。修改订单不支持修改此字段。
      if (this.isLMT || this.isAddPROFIT) {
        if (this.hasModifyOrderRequest) {
          return types.filter(t => t.value === this.outsideRth)
        }

        return types
      }
      return types.slice(0, 1)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .radio-box .radio-cell {
  max-width: 95px;
}
</style>
